import {
  GETKYBAPPROVEREJECT_SUCCESS,
  GETKYBAPPROVEREJECT_FAILED,
  RESET_GETKYBAPPROVEREJECT,
  LOADING_GETKYBAPPROVEREJECT,
  NETWORK_ERROR_GETKYBAPPROVEREJECT,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETKYBAPPROVEREJECT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETKYBAPPROVEREJECT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETKYBAPPROVEREJECT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETKYBAPPROVEREJECT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETKYBAPPROVEREJECT:
      return (state = initialState);
    default:
      return state;
  }
};
